import { useAuth0, type Auth0VueClient } from '@auth0/auth0-vue';

import { isServer } from '@/helpers/Platform/platform';

export const useAuth0Client = (): Auth0VueClient | null => {
  if (isServer()) {
    return null;
  }

  return useAuth0();
};
